<style>
    .footer {
      background-color: black;
      color: white;
      padding: 1rem 0;
    }
    .title {
      font-family: "dos", sans-serif;
      color: white;
      margin: 0;
    }
    .doslogo {
      font-family: "dos", sans-serif;
      color: white;
      margin: 0;
    }    
    /*.footer .container {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }*/
  </style>
  
  
  <footer class="footer">
    <div class="container">
<p class="is-6"><b>PolitoGroupsBot</b> // a <span class="doslogo">lynxcloud</span> public benefit services project. <br />&copy;2024 lynxcloud OdV Web Portals and/or its affiliates.</p>
    </div>
  </footer>
  